<template>
  <v-tooltip
    v-model="show"
    :nudge-top="cam.top < 50 ? 9 : -10"
    :bottom="cam.top < 50"
    :content-class="tooltipClass"
    :class="{ ['mapCam_tooltip-active']: true }"
    top
  >
    <template #activator="{ on, attrs }">
      <v-btn
        class="mapCam_camera"
        :style="{
          left: cam.left + 'px',
          bottom: cam.bottom + 'px',
          right: cam.right + 'px',
          top: cam.top + 'px',
          transform: `rotate(${cam.rotate}deg)`,
        }"
        icon
        v-bind="attrs"
        v-on="{ mouseenter: on.mouseenter, mouseleave: on.mouseleave }"
        @click="handleClick({ cam })"
      >
        <img :src="cam.active ? activeCamIcon : camIcon" class="mapCam_img" />
      </v-btn>
    </template>
    <div class="mapCam_tooltip-contain">
      <div v-if="cam.active" class="mapCam_active-icon">
        <span class="icon icon-check" />
      </div>
      <span v-html="cam.tooltip" />
    </div>
  </v-tooltip>
</template>

<script>
export default {
  name: 'MapCam',
  props: {
    cam: {
      type: Object,
      default: () => {},
    },
  },
  data: function () {
    return {
      show: false,
      camIcon: require('../../assets/img/map/camera.svg'),
      activeCamIcon: require('../../assets/img/map/camera-active.svg'),
    };
  },
  computed: {
    tooltipClass() {
      let tClass = 'mapCam_tooltip';
      if (this.cam.top < 50) {
        tClass += ' mapCam_tooltip-bottom';
        if (this.cam.active) {
          tClass += ' mapCam_tooltip-bottom-active';
        }
      } else if (this.cam.active) {
        tClass += ' mapCam_tooltip-active';
      }
      return tClass;
    },
  },
  methods: {
    handleClick({ cam }) {
      this.show = false;
      setTimeout(() => {
        this.show = true;
      }, 1);
      this.$emit('onClick', { cam });
    },
  },
};
</script>

<style lang="scss">
.mapCam {
  &_img {
    width: 26px;
  }
  &_active-icon {
    margin-right: 4px;
  }
  &_tooltip {
    padding: 5px;
    &-contain {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    &-active {
      color: #fff;
      background-color: #79c06e;
      &:after {
        border-top-color: #79c06e !important;
      }
    }
    &:after,
    &:before {
      top: 100%;
      left: 50%;
      border: solid transparent;
      content: '';
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
    }
    &:after {
      border-color: rgba(233, 244, 228, 0);
      border-top-color: #e9f4e4;
      border-width: 5px;
      margin-left: -5px;
    }
    &:before {
      border-color: rgba(55, 163, 74, 0);
      border-top-color: #37a34a;
      border-width: 6px;
      margin-left: -6px;
    }
    &-bottom {
      &:after,
      &:before {
        top: unset !important;
        bottom: 100%;
      }
      &-active {
        color: #fff;
        background-color: #79c06e;
        &:after {
          border-bottom-color: #79c06e !important;
        }
      }
      &:after {
        border-bottom-color: #e9f4e4;
        border-top-color: transparent;
      }
      &:before {
        border-bottom-color: #37a34a;
        border-top-color: transparent;
      }
    }
    box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.1);
    border: solid 1px #37a34a;
    background-color: #e9f4e4;
    color: #37a34a;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: normal;
    text-align: left;
  }
  &_camera {
    position: absolute;
  }
}
</style>
